import React from 'react';
import Paper from 'material-ui/Paper';

const style = {
  width: 250,
  minWidth: 250,
  minHeight: 400,
};

export default class Sidebar extends React.Component {
  render() {
    if (this.props.open) {
      return (
        <Paper style={style} zDepth={1}>
          {this.props.children}
        </Paper>
      );
    }
    return <div />;
  }
}

Sidebar.propTypes = {
  open: React.PropTypes.bool.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/controls/Sidebar.js